<template>
  <li class="notification">
     <!-- <p class="title">{{date}} - {{container}}</p>-->
      <p class="text">
       <!--  <span class="user" v-bind:style="{color: color}">{{user}}</span>-->
        {{text}}
      </p>
     
  </li>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex";

export default {
  name: "Notification",
  props: ["container", "text", "user", "date", "color"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("user", {
      authorized: "authorized",
    }),
  },
  methods: {},
};
</script>

<style lang= "scss" >
.notification{
  padding: 1em 2em;
  position: relative;

  &::after{
    content: ' ';
    width:80%;
    height: 1px;
    background-color: gainsboro;
    position: absolute;
    bottom: 0;
    left: 10%;
  }
  p{
    margin-bottom: 0;
  }
  p.text, span.user{
    font-size: .8rem;
  }
 
  
}

</style>
